module.exports = __webpack_public_path__ + "static/img/function-box-img1.6db26ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedProcess/function-box-img1.png
// module id = iC1D
// module chunks = 0